<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/molA41/images/9781592536986.jpg?1705160289244" alt="This image is the cover for the book 1000 Incredible Costume & Cosplay Ideas, 1000 Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1000 Incredible Costume & Cosplay Ideas, 1000 Series
      </h1>
      <p class="bookDescription body article font2">
        <b>If you think only Hollywood and Broadway costume designers can do spectacular, think again! A gallery of stunning and inspiring cosplay photography.</b><br/><br/><i>1000 Incredible Costume and Cosplay Ideas</i> provides a broad and detailed glimpse into the ingenious artistry and attention to detail behind some of the most fabulous costumes you’ll find anywhere . . . and most of them are designed by just regular folks who have a passion for the character they’re looking to emulate. From clothing to makeup to accessories, these costumes are like nothing you’ve seen before.<br/><br/>Featuring costumes from popular convention-goers to professional craftsmen, this stunning, photo-filled book by Joey Marsocci and Allison DeBlasio of Dr. Grymm Laboratories and Yaya Han walks you through scads of favorite characters as imagined and created by fans. Use it as inspiration for your next costume creation!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yaya Han, Allison DeBlasio, Joey Marsocci
      </h2>
      
      <p class="authorDescription body article">Allison DeBlasio (Mrs. Grymm) and her husband Joey Marsocci (Dr. Grymm) own Dr. Grymm Laboratories, a custom prop fabrication and fine art business based in Connecticut. They plan an annual Steampunk art exhibit called the Steampunk Bizarre which was hosted at Mark Twain House and Museum in the winter of 2012. They live in Middletown, CT and have two children who both love costumes and props already! Visit them online at http://www.drgrymmlaboratories.net.Joey Marsocci (Dr. Grymm) and his wife Allison DeBlasio (Mrs. Grymm) own Dr. Grymm Laboratories, a custom prop fabrication and fine art business based in Connecticut. They plan an annual Steampunk art exhibit called the Steampunk Bizarre which was hosted at Mark Twain House and Museum in the winter of 2012. Dr. Grymm has also appeared on the PBS OffBook series and the BBC America World Wide news speaking about his Steampunk Artwork. They live in Middletown, CT and have two children who both love costumes and props already! Visit them online at http://www.drgrymmlaboratories.net.Yaya Han is a US-based costume designer and cosplayer with 13 years of experience, an artistic model, and a widely-recognized ambassador for cosplay. Her intricate and lavish creations have won awards and acclaim nationwide, and she has been invited to appear as a guest, panelist, judge, performer and host to over 100 conventions and other events all over the world. To find out more information about Yaya, see more photos, and find out where she'll be next, visit her on the web at www.yayahan.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Quarry Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9f5e524a